import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { useAccountSelector } from './useAccountSelector';

export const useRedirectToCompleteAccountAfterSubmit = () => {
  const shouldNavigateToCompleteAccount = useSelector((state: any) => state.app.redirectToCompleteAccountAfterSubmit);
  const { account } = useAccountSelector();
  const navigate = useNavigate();

  useEffect(() => {
    if (shouldNavigateToCompleteAccount) {
      if (account?.accountId) {
        window.gtag('event', 'account', {
          accountId: account?.accountId,
        });
      }

      navigate('/complete-account');
      // TODO: dispatch action to remove redirect to complete account after submit
    }
  }, [shouldNavigateToCompleteAccount]);
};
